import React from 'react'
import './register.less'
import fj0 from './../../imgs/xieyi/物业项目情况表.docx'
import fj1 from './../../imgs/xieyi/智慧社区验收标准.docx'
import fj2 from './../../imgs/xieyi/彩之云平台功能清单.docx'
import fj3 from './../../imgs/xieyi/履约保函.docx'
import fj4 from './../../imgs/xieyi/年度应收金额约定.docx'
import { Modal } from 'antd';
const open = () => {
  return Modal.info({
    title: '物业云平台服务协议',
    okText: '确认',
    centered:true,
    width: 1000,
    keyboard:true,
    icon:'',
    className:'xieyi_modal1',
    maskClosable:true,
    footer:false,
    content: (
      <div class="WordSection1">

{/* <h3><span >物业云平台服务协议</span></h3> */}

<p style={{margin:'20 0px'}}><span>本协议是您与物业云平台<span lang="EN-US">(</span>简称物业云<span lang="EN-US">)</span>所有者和运营者深圳市彩生活网络服务有限公司<span lang="EN-US">(</span>以下简称为彩网或彩网公司<span lang="EN-US">)</span>之间就物业云服务等相关事宜所订立的契约，请您审慎阅读、充分理解各条款内容，特别是免除或者限制彩网责任的条款、对用户权利进行限制的条款、约定争议解决方式等条款，除非您接受本服务条款中所有条款，否则您无权注册、登录或使用本条款所涉相关服务。您的注册、登录、使用或者您点击“同意”或“下一步”或者以其他任何明示或者默示方式表示接受本协议的行为将视为对本服务协议内容的接受，并同意接受本服务条款各项条款的约束。</span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">1</span>条物业云服务条款的确认和接纳</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >1.1 </span><span >物业云平台的各项电子服务的所有权和运作权归彩网所有。用户同意所有注册协议条款完成注册程序并进行实名认证后，才能成为物业云的正式用户。用户确认：本协议条款是处理双方权利义务的契约，始终有效，法律另有强制性规定或双方另有特别约定的，依其规定。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >1.2 </span><span >用户点击同意本协议的，<u>即视为用户确认自己具有享受物业</u>云和功能等相应的权利能力和行为能力，能够独立承担法律责任。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >1.3</span><span >如果您是中国大陆地区以外的用户，您订立或履行本协议还需要同时遵守您所属和<span lang="EN-US">/</span>或所处国家或地区的法律。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >1.4</span><span >彩网保留在中华人民共和国大陆地区法施行之法律允许的范围内独自决定拒绝服务、关闭用户账户、清除或编辑内容的权利。</span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">2</span>条<span lang="EN-US">&nbsp;</span>物业云平台</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >2.1</span><span >、物业云平台通过互联网依法为用户提供互联网信息等服务，用户在完全同意本协议及物业云规定以及支付服务费用（如有）的情况下，方有权浏览物业云网页，或者获取相关权利方授权物业云相关服务的使用权。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >2.2</span><span >、用户必须自行准备如下设备和承担如下开支：</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >(1)</span><span >、上网设备，包括并不限于电脑或者其他上网终端、调制解调器及其他必备的上网装置<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >(2)</span><span >、上网开支，包括并不限于网络接入费、上网设备租用费、手机流量费等。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >2.3</span><span >用户可在物业云平台付费购买软件许可使用，并形成电子单据。</span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">3</span>条<span lang="EN-US">&nbsp;</span>用户信息</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >3.1</span><span >、用户应自行诚信向物业云平台提供注册资料，用户同意其提供的注册资料真实、准确、完整、合法有效，用户注册资料如有变动的，应及时更新其注册资料。如果用户提供的注册资料不合法、不真实、不准确、不详尽的，用户需承担因此引起的相应责任及后果，并且彩网保留终止用户使用物业云平台各项服务的权利。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >3.2</span><span >、用户注册成功后，将产生用户名和密码等账户信息，您可以根据物业云平台规定改变您的密码。用户应谨慎合理的保存、使用其用户名和密码。用户若发现任何非法使用用户账号或存在安全漏洞的情况，请立即通知物业云平台并向公安机关报案。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >3.3</span><span >、用户同意，彩网及其关联方或合作方拥有通过邮件、短信电话等形式，向在物业云平台注册用户发送信息的权利。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >3.4</span><span >、用户不得将在物业云平台注册获得的账户借给他人使用，否则用户应承担由此产生的全部责任，并与实际使用人承担连带责任。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >3.5</span><span >、用户同意，彩网有权使用用户的注册信息、用户名、密码等信息，登陆进入用户的注册账户，进行证据保全，包括但不限于公证、见证等。</span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">4</span>条<span lang="EN-US">&nbsp;</span>用户依法言行义务</span></p>

<p style={{margin:'20 0px'}}><span>本协议依据国家相关法律法规规章制定，用户同意严格遵守以下义务：</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >4.1</span><span >、不得传输或发表：煽动抗拒、破坏宪法和法律、行政法规实施的言论，煽动颠覆国家政权，推翻社会主义制度的言论，煽动分裂国家、破坏国家统一的的言论，煽动民族仇恨、民族歧视、破坏民族团结的言论<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >4.2</span><span >、从中国大陆向境外传输资料信息时必须符合中国有关法规<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >4.3</span><span >、不得利用物业云平台从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >4.4</span><span >、不得干扰物业云平台的正常运转，不得侵入物业云平台及国家计算机信息系统<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >4.5</span><span >、不得传输或发表任何违法犯罪的、骚扰性的、中伤他人的、辱骂性的、恐吓性的、伤害性的、庸俗的，淫秽的、不文明的等信息资料<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >4.6</span><span >、不得传输或发表损害国家社会公共利益和涉及国家安全的信息资料或言论<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >4.7</span><span >、不得教唆他人从事本条所禁止的行为<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >4.8</span><span >、不得利用在物业云平台注册的账户进行牟利性经营活动<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >4.9</span><span >、不得发布任何侵犯他人著作权、商标权等知识产权或合法权利的内容<span lang="EN-US">;</span></span></p>

<p style={{margin:'20 0px'}}><span>用户应不时关注并遵守物业云平台不时公布或修改的各类合法规则规定。</span></p>

<p style={{margin:'20 0px'}}><span>物业云平台保有删除<span lang="EN-US">APP</span>内各类不符合法律政策或不真实的信息内容而无须通知用户的权利。</span></p>

<p style={{margin:'20 0px'}}><span>若用户未遵守以上规定的，物业云平台有权作出独立判断并采取暂停或关闭用户帐号等措施。用户须对自己在网上的言论和行为承担法律责任。</span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">5</span>条<span lang="EN-US">&nbsp;</span>所有权及知识产权条款</span></p>

<p><span lang="EN-US" >5.1</span><span >、彩网保留对以下各项内容、信息完全的、不可分割的所有权及知识产权：除用户自行上载、传播的内容外，物业云平台服务及其所有元素，包括但不限于所有内容、数据、技术、软件、代码、用户界面、为不同用户个性化开发的服务以及与其相关的任何衍生作品；用户信息；用户向物业云平台服务提供的与该平台服务相关的任何信息及反馈。</span></p>

<p><span lang="EN-US" >5.2</span><span >、彩网是物业云平台的制作者<span lang="EN-US">,</span>拥有网页内容及资源的著作权等合法权利<span lang="EN-US">,</span>受国家法律保护<span lang="EN-US">,</span>有权不时地对本协议及物业云平台的内容进行修改，并在平台上张贴，无须另行通知用户。在法律允许的最大限度范围内，彩网对本协议及物业云平台内容拥有解释权。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >5.3</span><span >、除法律另有强制性规定外，未经彩网明确的特别书面许可<span lang="EN-US">,</span>任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用物业云平台的信息内容，否则，彩网有权追究其法律责任。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >5.4</span><span >、物业云平台所刊登的资料信息<span lang="EN-US">(</span>诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件<span lang="EN-US">)</span>，均是彩网或其内容提供者的财产，受中国和国际知识产权法的保护。物业云平台上所有内容的汇编是彩网的排他财产，受中国和国际知识产权法的保护。本物业云平台上所有软件都是彩网或其关联公司或其软件供应商的财产，受中国和国际知识产权法的保护。</span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">6</span>条<span lang="EN-US">&nbsp;</span>责任限制及不承诺担保</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >6.1 </span><span >除非另有明确的书面说明<span lang="EN-US">,</span>物业云平台及其所包含的或以其它方式通过物业云平台提供给您的全部信息、内容、材料、产品<span lang="EN-US">(</span>包括软件<span lang="EN-US">)</span>和服务，均是在按现状和按现有的基础上提供的。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >6.2 </span><span >除非另有明确的书面说明<span lang="EN-US">,</span>彩网不对物业云平台的运营及其包含在物业云平台上的信息、内容、材料、产品<span lang="EN-US">(</span>包括软件<span lang="EN-US">)</span>或服务作任何形式的、明示或默示的声明或担保<span lang="EN-US">(</span>根据中华人民共和国法律另有规定的以外<span lang="EN-US">&nbsp;)</span>。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >6.3 </span><span >彩网不担保物业云平台所包含的或以其它方式通过物业云平台提供给您的全部信息、内容、材料、产品<span lang="EN-US">(</span>包括软件<span lang="EN-US">)</span>和服务、其服务器或从物业云平台发出的电子信件、信息没有病毒或其他有害成分。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >6.4 </span><span >如因不可抗力或其它物业云平台无法控制的原因使物业云平台销售系统崩溃或无法正常使用导致网上交易无法完成或丢失有关的信息、记录等，彩网会合理地尽力协助处理善后事宜，但是由此给您造成的损失彩网免责。</span></p>

<p style={{margin:'20 0px'}}><span >彩网对以下情形导致的服务中断或受阻不承担责任：</span></p>

<p style={{margin:'20 0px'}}><span >（<span lang="EN-US">1</span>）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏。</span></p>

<p style={{margin:'20 0px'}}><span >（<span lang="EN-US">2</span>）用户或彩网的电脑软件、系统、硬件和通信线路出现故障。</span></p>

<p style={{margin:'20 0px'}}><span >（<span lang="EN-US">3</span>）用户操作不当或用户通过非彩网授权的方式使用本服务。程序版本过时、设备的老化和<span lang="EN-US">/</span>或其兼容性问题。</span></p>

<p style={{margin:'20 0px'}}><span >（<span lang="EN-US">4</span>）其他彩网无法控制或合理预见的情形。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >6.5</span><span >用户在使用物业云平台过程中，上传或者共享的数据信息侵害第三方权益的，彩网免责且不对用户做任何明示或者暗示的担保，彩网有权暂停或者终止向用户提供服务并有权要求用户对彩网因此造成的损失承担赔偿责任。<span class="msoIns"><ins cite="mailto:李%20玉华" datetime="2020-06-22T16:59"> <span lang="EN-US">&nbsp;&nbsp;</span></ins></span></span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">7</span>条<span lang="EN-US">&nbsp;</span>用户信息保护</span></p>

<p class="MsoNormal"><span lang="EN-US" >7.1</span><span >保护用户信息是彩网的一项基本原则。</span></p>

<p class="MsoNormal"><span lang="EN-US" >7.2</span><span >彩网将按照本协议及《物业云法律声明与隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息保护相关内容未作明确规定的，均应以《物业云法律声明与隐私政策》的内容为准。</span></p>

<p class="MsoNormal"><span lang="EN-US" >7.3</span><span >对于用户因为使用物业云平台上传或者共享的数据，用户须保证以上数据不侵害第三方权益，如有，与彩网无关，由用户自行处理解决。对于用户上传或者共享的数据，彩网均有权无偿对数据进行储存、使用等。</span></p>

<p class="MsoNormal"><span lang="EN-US" >7.4</span><span >您在注册帐号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息或者提供真实数据。若您填写的信息不完整或者不真实，则可能无法使用本服务或在使用过程中受到限制。</span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">8</span>条 协议更新及用户关注义务</span></p>

<p style={{margin:'20 0px'}}><span>根据国家法律法规变化及网页运营需要，彩网有权对本协议条款不时地进行修改，修改后的协议一旦被张贴在物业云平台上即生效，并代替原来的协议。用户可随时登陆查阅最新协议<span lang="EN-US">;</span>用户有义务不时关注并阅读最新版的协议及网页公告。如用户不同意更新后的协议，可以且应立即停止接受彩管家网页依据本协议提供的服务<span lang="EN-US">;</span>如用户继续使用物业云平台提供的服务的，即视为同意更新后的协议。彩网建议您在使用物业云平台之前阅读本协议及物业云平台的公告。<span lang="EN-US">&nbsp;</span>如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。</span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">9</span>条<span lang="EN-US">&nbsp;</span>法律管辖和适用</span></p>

<p style={{margin:'20 0px'}}><span>本协议的订立、执行和解释及争议的解决均应适用在中华人民共和国大陆地区适用之有效法律<span lang="EN-US">(</span>但不包括其冲突法规则<span lang="EN-US">)</span>。<span lang="EN-US">&nbsp;</span>如发生本协议与适用之法律相抵触时，则这些条款将完全按法律规定重新解释，而其它有效条款继续有效。<span lang="EN-US">&nbsp;</span>如缔约方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决<span lang="EN-US">;</span>协商不成时，任何一方均可向有管辖权的中华人民共和国大陆地区法院提起诉讼。</span></p>

<p style={{margin:'32 0px', fontWeight: 700}}><span>第<span lang="EN-US">10</span>条<span lang="EN-US">&nbsp;</span>其他</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >12.1</span><span >物业云平台所有者是指在政府部门依法许可或备案的经营主体。</span></p>

<p style={{margin:'20 0px'}}><span lang="EN-US" >12.2</span><span >彩网尊重用户和消费者的合法权利，本协议及物业云平台上发布的各类规则、声明等其他内容，均是为了更好的、更加便利的为用户和消费者提供服务。物业云平台欢迎用户和社会各界提出意见和建议，彩网将虚心接受并适时修改本协议及物业云平台上的各类规则。</span></p>

<p class="MsoNormal"><span lang="EN-US">&nbsp;</span></p>

</div>
    ),
    onOk() { },
  });
}
export default open


// WEBPACK FOOTER //
// ./src/pages/register/xieyi.jsx